/**
 * Site-wide footer. Rendered once at the App level so it appears on
 * every page (Landing, Upload, Result, CheckoutSuccess). Contains a
 * bilingual support-contact mailto so users always have a way to
 * reach us.
 */
export default function SiteFooter() {
    return (
        <footer
            data-testid="site-footer"
            className="w-full border-t border-white/5 bg-[#0A0A0C] text-white/60"
        >
            <div className="max-w-3xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs font-cn">
                <span data-testid="site-footer-brand">
                    郝给力 · haogeili
                </span>
                <span data-testid="site-footer-contact">
                    联系 / Contact:{" "}
                    <a
                        href="mailto:support@haogeili.app"
                        data-testid="site-footer-support-link"
                        className="text-white/80 hover:text-white underline underline-offset-2 transition-colors"
                    >
                        support@haogeili.app
                    </a>
                </span>
            </div>
        </footer>
    );
}
